import React, { useState } from 'react';
import createStyle from 'shared-utils/src/createStyle';

import Grid from '../Grid';
import GridItem from '../GridItem';
import style, { mainCls } from './style';
import makeClassName from 'shared-utils/src/makeClassName';

const useStyles = createStyle(style);

const DialogConfirm = ({ confirm, discard, showDialog, close }) => {
  const cls = useStyles();

  const clsMain = makeClassName([
    mainCls, 
    `${mainCls}--fixed`, 
    'is-over--hid',
    showDialog && `${mainCls}--open`,
  ]);

  const clsConfirm = makeClassName([
    `${mainCls}__conf`, 
    showDialog && `${mainCls}__conf--up`
  ]);

  return (
    <div className={clsMain}>
      <div className={`${mainCls}--ovrl`} onClick={close} />
      <Grid direction="column" className={clsConfirm}>
        <GridItem behavior="stretch">
          <Grid
            align="center"
            justify="center"
            className={`${mainCls}__conf__text tp-a--c`}
          >
            <p className={`tp-s--l tp-w--l c-txt--f0`}>
              <>
                <strong>Cancella tutto</strong>
                <span
                  className={`${mainCls}__conf__text--blk pt--xs tp-s--xs tp-w--s c-txt--f0`}
                >
                  Vuoi cancellare tutti i filtri?
                </span>
              </>
            </p>
          </Grid>
        </GridItem>
        <GridItem behavior="fixed" className={`${mainCls}__conf__btns is-rel`}>
          <button
            type="button"
            className={`${mainCls}__conf__btn tp-s--l tp-w--m c-txt--f0 is-clickable`}
            onClick={discard}
          >
            Annulla
          </button>
          <button
            type="button"
            className={`${mainCls}__conf__btn tp-s--l tp-w--m c-txt--f0 is-clickable`}
            onClick={confirm}
          >
            Conferma
          </button>
        </GridItem>
      </Grid>
    </div>
  );
};

export default DialogConfirm;
